// extracted by mini-css-extract-plugin
module.exports = {"TilesSticky":"TilesSticky_TilesSticky__5F00r","wrapper":"TilesSticky_wrapper__iDttb","item":"TilesSticky_item__r67EE"};